import { render, staticRenderFns } from "./IntegralList.vue?vue&type=template&id=39fdaca6&scoped=true"
import script from "./IntegralList.vue?vue&type=script&lang=js"
export * from "./IntegralList.vue?vue&type=script&lang=js"
import style0 from "./IntegralList.vue?vue&type=style&index=0&id=39fdaca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fdaca6",
  null
  
)

export default component.exports